// extracted by mini-css-extract-plugin
module.exports = {"footer":"Survey_footer__9jaUd","survey":"Survey_survey__1gpjo"};